import _ from 'underscore';
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '@bingads-webui-campaign-react/router';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { SummaryBarFactory } from '@bingads-webui-campaign-react/summary-bar';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { withScope } from '@bingads-webui-react/scope-service';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';

function getConfig(props) {
  const {
    i18n, scope, portfolioName, permissions,
  } = props;

  let pathname = '/campaign/vnext/portfoliobidstrategy';

  const isDataExclusionEnabled = (permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions);
  // If data exclusion is enabled, the routing of portfoliobidstrategy is also changed
  if (isDataExclusionEnabled) {
    pathname = '/campaign/vnext/bidstrategies/portfoliobidstrategy';
  }
  const search = scope.stringify(_.omit(scope.values, 'portfolioId'));

  return {
    backButtonProps: {
      url: `${pathname}?${search}`,
      buttonText: i18n.getString(_TL_('Back to portfolio bid strategies')),
    },
    breadcrumbsGeneralConfigs: {
      items: [
        {
          key: 'portfolio-bid-strategies',
          text: i18n.getString(_TL_('Portfolio bid strategies')),
          'aria-label': i18n.getString(_TL_('Portfolio bid strategies')),
          onClick: () => {
            scope.history.push({ pathname, search });
          },
        }, {
          key: 'portfolio-bid-strategy-details',
          text: portfolioName || i18n.getString(_TL_('Details')),
          'aria-label': i18n.getString(_TL_('Details')),
          isCurrentItem: true,
        },
      ],
      maxDisplayedItems: 2,
    },
  };
}


const Loader = (props) => {
  const { updateAvailability, isVisible, ...others } = props;
  const { i18n, siteMap, scope } = others;
  const permissions = useContext(PermissionsContext);

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  if (selectedParent) {
    const summaryBarFallback = <SummaryBarFactory {...getConfig({ i18n, scope, permissions })} {...others} />;

    const { portfolioId } = scope.values;

    if (portfolioId && isVisible) {
      return (
        <CampaignOData
          call={({ currentAccount }) => currentAccount.PortfolioBidStrategies.$withKey(portfolioId).get()}
          escapeHatch={({ currentAccount }) => (currentAccount ? undefined : { value: summaryBarFallback })}
          fallback={summaryBarFallback}
          onError={() => summaryBarFallback}
        >
          {(response) => {
            const portfolioName = response.Name;

            return portfolioName ?
              <SummaryBarFactory {...getConfig({ i18n, scope, portfolioName, permissions })} {...others} /> :
              summaryBarFallback;
          }}
        </CampaignOData>
      );
    }

    return summaryBarFallback;
  }

  return null;
};

Loader.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      selListId: PropTypes.number,
    }).isRequired,
  }).isRequired,
  isVisible: PropTypes.bool.isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const PortfolioDetailsLoader = withScope(withRouter(React.memo(Loader)));
